export const fullHeight = {height: '100%', maxHeight: '100%'}
export const fullWidth = {width: '100%', maxWidth: '100%'}
export const pointer = {cursor: 'pointer'}

export function promiseState(p: Promise<any>) {
    const t = {};
    return Promise.race([p, t])
        .then(v => (v === t) ? "pending" : "fulfilled", () => "rejected");
}

export const hasPromisePending = (promises: Promise<any>[]) => {
    return promises.some(p => {
        return promiseState(p).then(state => state === "pending");
    });
}